import { Component, OnInit } from "@angular/core";

@Component({
	standalone: false,
	selector: "ay-page-main-side",
	template: "<ng-content></ng-content>",
})
export class AyPageMainSideComponent implements OnInit {
	constructor() {}

	ngOnInit() {}
}
